import { render, staticRenderFns } from "./stock-mapping-location.vue?vue&type=template&id=795f9779&scoped=true"
import script from "./stock-mapping-location.vue?vue&type=script&lang=ts"
export * from "./stock-mapping-location.vue?vue&type=script&lang=ts"
import style0 from "./stock-mapping-location.vue?vue&type=style&index=0&id=795f9779&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "795f9779",
  null
  
)

export default component.exports